import React from 'react';
import _ from 'lodash';
import { stateMap } from 'config';
import { useDispatch, useSelector } from 'react-redux';
import { setFilters } from 'redux/slices/dataSlice';
import {
  InputLabel,
  ListItemText,
  OutlinedInput,
  Checkbox,
  Select, FormControl,
  MenuItem,
  makeStyles,
  Grid
} from '@material-ui/core';
import { filterByOperationStatusSelector, filterByOperationTypesSelector } from 'redux/selectors';
import { operationTypes } from 'constants/operationTypes';

const opStatus = _.toPairs(stateMap);

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: '100%',
    textAlign: 'center',
  },
  inputLabel: {
    paddingLeft: '1rem',
  }
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 1;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function MultipleSelect() {
  const dispatch = useDispatch();
  const filterOperationStatus = useSelector(filterByOperationStatusSelector) || [];
  const filterOperationTypes = useSelector(filterByOperationTypesSelector) || null;
  const classes = useStyles();

  const status = {};
  opStatus.forEach(value => {
    status[value[1]] = value[0]
  })

  const filterConvert = (value) => {
    switch (value) {
      case 1:
        return "Inicial"
      case 2:
        return "Pendiente"
      case 3:
        return "Éxito"
      case 4:
        return "Rechazado"
      case 5:
        return "Cancelado"
      case 6:
        return "Firmado"
      case 7:
        return "Visto"
      default:
    }
  }

  const handleChangeType = (event) => {
    dispatch(
      setFilters({
        filterByOperationTypes: event.target.value
      })
    );
  };

  const handleChange = (event) => {
    const newValue = event.target.value;
    const stateValue = newValue.map(val => parseInt(status[val]))
    dispatch(
      setFilters({
        filterByOperationStatus: stateValue
      })
    );
  };

  return (
    <Grid container spacing={2} item xs={8}>
      <Grid item xs={6}>
        <FormControl size="small" fullWidth={true} margin='dense' className={classes.formControl}>
          <InputLabel className={classes.inputLabel} htmlFor="grouped-native-select">Filtrar por estados</InputLabel>
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            value={filterOperationStatus.map(s => filterConvert(s))}
            onChange={handleChange}
            input={<OutlinedInput label="Tag" />}
            renderValue={(selected) => selected.join(', ')}
            MenuProps={MenuProps}
          >
            <MenuItem disabled value="x">
              <em>Estados</em>
            </MenuItem>
            {opStatus.map((status, idx) => (
              <MenuItem key={idx} value={status[1]}>
                <Checkbox checked={filterOperationStatus.indexOf(Number(status[0])) > -1} />
                <ListItemText primary={status[1]} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={5}>
        <FormControl size="small" fullWidth margin='dense' className={classes.formControl} variant="outlined">
          <InputLabel id="select-label" className={classes.inputLabel} htmlFor="grouped-native-select">Filtrar por Tipo</InputLabel>
          <Select
            labelId="select-label"
            id="select"
            value={filterOperationTypes}
            label="Type Operation"
            displayEmpty
            onChange={handleChangeType}
          >
            <MenuItem value={null}> </MenuItem>
            <MenuItem value={operationTypes.master}>{operationTypes[operationTypes.master]}</MenuItem>
            <MenuItem value={operationTypes.upgrade}>{operationTypes[operationTypes.upgrade]}</MenuItem>
            <MenuItem value={operationTypes.visa}>{operationTypes[operationTypes.visa]}</MenuItem>
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
}
